import React from "react";

const Credits = () => (
  <div className="credits-terms">
    <p>
      <small>
        Link Tooltips and Search Results powered by WoWHead.
        <br /> This site is open source, the source code can be found on the Github page.
        <br /> I do not claim ownership of any World of Warcraft related assets, this is just a fan
        site!
      </small>
    </p>
  </div>
);

export default Credits;
